import { assign } from 'xstate';

import { createProductAdds } from '../../helpers';
import { type BundleMachineAction, type SelectedProduct } from '../../types';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Queues every product of the bundle for adding, in selection order.
 */
export const startProductAdds: BundleMachineAction = assign((args) => {
  const { context } = args;

  return {
    productAdds: createProductAdds(context.selectedProducts.map(getSelectionId)),
  };
});

// ─── Helpers ─────────────────────────────────────────────────────────────────

function getSelectionId(selectedProduct: SelectedProduct) {
  return selectedProduct.selectionId;
}
